import React, { useState } from "react";
import DeletePost from "./DeletePost";
import "./edit_deletePost.css";
import CreatePostFirst from "../../Create_Post_screen/CreatePostFirst";
import { Pencil, Trash2 } from "lucide-react";

const ThreeDot_Post_Popup = ({
  setPostEdit,
  setPostThreedot,
  communityId,
  post_id,
}) => {
  const [delet1, setDelet1] = useState(false);

  return (
    <>
      <div className=" p-3 PostPopupBox ">
        <button
          className="Post_popup_btn flex gap-2 items-center"
          onClick={() => {
            setPostEdit(true);
            setPostThreedot(false);
          }}
        >
          <Pencil size={16} />  <span>Edit Post</span>
        </button>
        <button className="Post_popup_btn flex gap-2 items-center" onClick={(e) => setDelet1(true)}>
          <Trash2 size={16} color="red" />  <span>Delete Post</span>
        </button>
      </div>
      {delet1 && (
        <DeletePost
          setDelet1={setDelet1}
          communityId={communityId}
          post_id={post_id}
        />
      )}
    </>
  );
};

export default ThreeDot_Post_Popup;
